// src/pages/Login.js
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { TextField, Button, Container, Typography, Checkbox, FormControlLabel, Box, Alert } from '@mui/material';
import axios from 'axios';
import { primaryColor } from '../theme';
import logo from '../assets/Equity logo.png';
import illustration from '../assets/Equity logo.png';

const Login = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [rememberMe, setRememberMe] = useState(false);
  const [error, setError] = useState('');

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    if (name === 'email') setEmail(value);
    if (name === 'password') setPassword(value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/auth/login`, { email, password });
      const { token, user } = response.data;
      localStorage.setItem('token', token);
      localStorage.setItem('user', JSON.stringify(user));
      switch (user.role) {
        case 'Head Office Admin':
          navigate('/admin/dashboard');
          break;
        case 'Regional Manager':
          navigate('/coordinator/dashboard');
          break;
        case 'Content Editor':
          navigate('/editor/dashboard');
          break;
        case 'Content Reviewer':
          navigate('/approver/dashboard');
          break;
        case 'Trainer':
          navigate('/branch/dashboard');
          break;
        default:
          navigate('/login');
      }
    } catch (error) {
      console.error('Error logging in:', error);
      setError(error.response?.data?.msg || 'Failed to log in');
    }
  };

  return (
    <Box display="flex" height="100vh">
      <Box
        flex={1}
        display={{ xs: 'none', md: 'flex' }}
        alignItems="center"
        justifyContent="center"
        bgcolor={primaryColor}
      >
        {/* <img src={illustration} alt="Illustration" style={{ width: '80%', height: 'auto' }} /> */}
      </Box>
      <Box
        flex={1}
        display="flex"
        alignItems="center"
        justifyContent="center"
      >
        <Container maxWidth="sm">
          <Box display="flex" flexDirection="column" alignItems="center">
            <img src={logo} alt="Logo" style={{ width: '150px', marginBottom: '20px' }} />
            <Typography variant="h4" component="h1" gutterBottom>
              Content Portal Login
            </Typography>
            {error && (
              <Alert severity="error" sx={{ mt: 2 }}>
                {error}
              </Alert>
            )}
            <form onSubmit={handleSubmit} style={{ width: '100%' }}>
              <TextField
                label="Email"
                name="email"
                variant="outlined"
                fullWidth
                margin="normal"
                value={email}
                onChange={handleInputChange}
              />
              <TextField
                label="Password"
                name="password"
                type="password"
                variant="outlined"
                fullWidth
                margin="normal"
                value={password}
                onChange={handleInputChange}
              />
              <FormControlLabel
                control={<Checkbox checked={rememberMe} onChange={(e) => setRememberMe(e.target.checked)} />}
                label="Remember Me"
              />
              <Button type="submit" variant="contained" color="primary" fullWidth style={{ backgroundColor: primaryColor }}>
                Login
              </Button>
              <Typography variant="body2" align="right" style={{ marginTop: '10px' }}>
                <a href="/password/forgot" style={{ color: primaryColor }}>Forgot Password?</a>
              </Typography>
            </form>
          </Box>
        </Container>
      </Box>
    </Box>
  );
};

export default Login;